(function ($) {


	/*-------------------------------------------
	 pickup_nav
	 -------------------------------------------*/
	$(function () {
		const $nav = $('.pickup_nav');
		const $sec = $('#sec_pickup');
		const $body = $('#pickup_body');
		const $cntWrap = $('#pickup_vio .cnt_wrap');
		const $note = $('.note_wrap');

		$(window).on('scroll', function () {
			if ($(window).width() <= 896) return;

			const scrollTop = $(window).scrollTop();
			const winH = $(window).height();
			const centerY = scrollTop + winH / 2;

			// is-fixed / is-bottom の判定
			const secTop = $sec.offset().top;
			const cntWrapBottom = $cntWrap.offset().top + $cntWrap.outerHeight();
			const noteH = $note.outerHeight(true);

			if (scrollTop >= secTop && scrollTop + winH < cntWrapBottom) {
				$nav.addClass('is-fixed').removeClass('is-bottom');
				$nav.css('bottom', '');
			} else if (scrollTop + winH >= cntWrapBottom) {
				$nav.removeClass('is-fixed').addClass('is-bottom');
				$nav.css('bottom', noteH + 'px');
			} else {
				$nav.removeClass('is-fixed is-bottom');
				$nav.css('bottom', '');
			}

			// is-current & is-white の判定
			$nav.find('a').each(function () {
				const targetId = $(this).attr('href');
				const $target = $(targetId);
				if (!$target.length) return;

				const blockTop = $target.offset().top;
				const blockBottom = blockTop + $target.outerHeight();

				if (centerY >= blockTop && centerY <= blockBottom) {
					$(this).closest('li').addClass('is-current');

					if (targetId === '#pickup_face') {
						$nav.addClass('is-white');
					} else {
						$nav.removeClass('is-white');
					}
				} else {
					$(this).closest('li').removeClass('is-current');
				}
			});
		});
	});

	/*-------------------------------------------
	 smooth scroll
	 -------------------------------------------*/
	$(function () {
		var headerHeight = $('#header').outerHeight();
		var urlHash = location.hash;
		if (urlHash) {
			$('body,html').stop().scrollTop(0);
			setTimeout(function () {
				var target = $(urlHash);
				var position = target.offset().top - headerHeight;
				$('body,html').stop().animate({
					scrollTop: position
				}, 500);
			}, 100);
		}
		$('a[href^="#"]').click(function () {
			var target = $(this.hash);
			var position = target.offset().top - headerHeight;
			$('body,html').stop().animate({
				scrollTop: position
			}, 500);
			return false;
		});
	});

	/*====================================
	scroll anime
	====================================*/
	$(window).on('scroll', function () {
		const scrollTop = $(this).scrollTop();
		const wh = $(window).height();

		$('.js-anime').each(function () {
			if (scrollTop > $(this).offset().top - wh + wh / 4) {
				$(this).addClass('js-animeOn');
			}
		});
	});

	/*
	 * css swicher
	 */
	function css_browser_selector(u) {
		var ua = u.toLowerCase(),
			is = function (t) {
				return ua.indexOf(t) > -1
			},
			e = 'edge',
			g = 'gecko',
			w = 'webkit',
			s = 'safari',
			o = 'opera',
			m = 'mobile',
			h = document.documentElement,
			b = [
				(!(/opera|webtv/i.test(ua)) && /msie\s(\d)/.test(ua)) ? ('ie ie' + RegExp.$1) :
					!(/opera|webtv/i.test(ua)) && is('trident') && /rv:(\d+)/.test(ua) ? ('ie ie' + RegExp.$1) :
						is('edge/') ? e :
							is('firefox/2') ? g + ' ff2' :
								is('firefox/3.5') ? g + ' ff3 ff3_5' :
									is('firefox/3.6') ? g + ' ff3 ff3_6' : is('firefox/3') ? g + ' ff3' :
										is('gecko/') ? g :
											is('opera') ? o + (/version\/(\d+)/.test(ua) ? ' ' + o + RegExp.$1 :
												(/opera(\s|\/)(\d+)/.test(ua) ? ' ' + o + RegExp.$2 : '')) :
												is('konqueror') ? 'konqueror' :
													is('blackberry') ? m + ' blackberry' :
														is('android') ? m + ' android' :
															is('chrome') ? w + ' chrome' :
																is('iron') ? w + ' iron' :
																	is('applewebkit/') ? w + ' ' + s + (/version\/(\d+)/.test(ua) ? ' ' + s + RegExp.$1 : '') :
																		is('mozilla/') ? g :
																			'',
				is('j2me') ? m + ' j2me' :
					is('iphone') ? m + ' iphone' :
						is('ipod') ? m + ' ipod' :
							is('ipad') ? m + ' ipad' :
								is('mac') ? 'mac' :
									is('darwin') ? 'mac' :
										is('webtv') ? 'webtv' :
											is('win') ? 'win' + (is('windows nt 6.0') ? ' vista' : '') :
												is('freebsd') ? 'freebsd' :
													(is('x11') || is('linux')) ? 'linux' :
														'',
				'js'
			];
		c = b.join(' ');
		h.className += ' ' + c;
		return c;
	};
	css_browser_selector(navigator.userAgent);


})(jQuery);